import Database from 'database';
import { Pem, Queue } from 'models';
import moment from 'moment';
import { Creators as queueCreators } from './queue';

export const Types = {
  GET_PEMS: 'pems/GET_PEMS',
  GET_PEMS_SUCCESS: 'pems/GET_PEMS_SUCCESS',
  GET_PEMS_FAILED: 'pems/GET_PEMS_FAILED',
  ADD_PEM: 'pems/ADD_PEM',
  ADD_PEM_SUCCESS: 'pems/ADD_PEM_SUCCESS',
  ADD_PEM_FAILED: 'pems/ADD_PEM_FAILED',
  CLEAR_PEM_ERROR: 'pems/CLEAR_PEM_ERROR',
};

/**
 * @type {{
  loading: boolean,
  error: string | null,
  data: PemAPI[],
  filter: [],
  created: PemAPI | null
}}
 */
const initialState = {
  loading: false,
  error: null,
  data: [],
  filter: [],
  created: null,
};

export default function pemsReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_PEMS:
      return { ...state, loading: true };
    case Types.GET_PEMS_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case Types.GET_PEMS_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.ADD_PEM:
      return { ...state, loading: true };
    case Types.ADD_PEM_SUCCESS:
      return { ...state, loading: true, created: action.createdPEM };
    case Types.ADD_PEM_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.CLEAR_PEM_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
}

export function updateCreatedPEM(createdPem) {
  return {
    type: Types.ADD_PEM_SUCCESS,
    createdPEM: createdPem ? {
      ...createdPem,
      id: createdPem._id,
    } : createdPem,
  };
}

export const Creators = {
  getPems: (condition) => async (dispatch) => {
    try {
      dispatch({ type: Types.GET_PEMS });
      const pems = (await Database.pems.toArray()).sort((a, b) =>
        moment(a.data) < moment(b.data) ? 1 : -1,
      );

      // eslint-disable-next-line no-restricted-syntax
      const cidades = await Database.cidades.toArray();
      const culturas = await Database.culturas.toArray();
      for (let i = 0; i < pems.length; i++) {
        const pem = pems[i];
        pems[i] = {
          ...pem,
          nome: pem.nome || `(offline) ${pem.produtor}`,
          id: pem.id || pem._id,
          cidade: cidades.find((x) => x.id === pem.cidade_id) || {},
          cultura: culturas.find((x) => x.id === pem.cultura_id) || {},
          etec: JSON.parse(localStorage.getItem('udata')),
          user: JSON.parse(localStorage.getItem('udata')),
          user_id: pem.user_id || JSON.parse(localStorage.getItem('udata')).id,
          etec_id: JSON.parse(localStorage.getItem('udata')).id,
        };
      }
      const filteredPems = pems.filter(condition || (() => true));

      dispatch({
        type: Types.GET_PEMS_SUCCESS,
        payload: { data: pems, filter: filteredPems },
      });
    } catch (woof) {
      console.error(woof.message);
      dispatch({
        type: Types.GET_PEMS_FAILED,
        payload: { error: 'Serviço indisponível' },
      });
    }
  },
  /**
   * @param {Object} data
   * @param {string} data.cultura
   * @param {string} data.ETEC
   * @param {string} data.estado
   * @param {string} data.municipio
   * @param {String} data.produtor
   * @param {String} data.data
   */
  addPem: ({ ETEC, cultura, estado, municipio, produtor, data }) => async (
    dispatch,
  ) => {
    const produtorx = produtor;
    const datax = data;
    try {
      dispatch({ type: Types.ADD_PEM });
      if (
        typeof ETEC !== 'number' ||
        typeof cultura !== 'number' ||
        typeof estado !== 'number' ||
        typeof municipio !== 'number' ||
        typeof produtor !== 'string' ||
        !produtor.length ||
        typeof data !== 'string' ||
        data.length !== 10
      ) {
        throw new Error('invalid data');
      }
      if (
        (await Database.pems.toArray()).find(
          ({ cultura_id, produtor, etec_id, data }) =>
            String(cultura_id) === String(cultura) &&
            String(etec_id) === String(ETEC) &&
            moment(data).isSame(moment(datax), 'month') &&
            String(produtor) === String(produtorx),
        )
      ) {
        dispatch({
          type: Types.ADD_PEM_FAILED,
          payload: { error: 'duplicate entry' },
        });
        return;
      }
      const pemData = {
        cultura_id: cultura,
        etec_id: ETEC,
        estado_id: estado,
        cidade_id: municipio,
        produtor,
        data: moment(data).format('YYYY-MM-DD'),
      };
      const pem = new Pem({
        ...pemData,
        hasBeenSent: false,
        created_at: new Date().toISOString(),
      });
      await pem.save();
      const queue = new Queue({
        table: 'pems',
        localId: pem._id,
        requestBody: pemData,
      });
      await queue.save();
      dispatch(queueCreators.getQueue());
      dispatch(queueCreators.ping());
      dispatch(Creators.getPems());
      dispatch(updateCreatedPEM(pem));
    } catch (woof) {
      console.log(woof.message);
      dispatch({
        type: Types.ADD_PEM_FAILED,
        payload: { error: (woof && woof.message) || 'Serviço indisponível' },
      });
    }
  },
  resetPemAdded: () => ({ type: Types.RESET_PEM_ADDED }),
  clearPemError: () => ({ type: Types.CLEAR_PEM_ERROR }),
};
